import React from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Button,
    IconButton,
    Typography
} from '@material-ui/core';
import MicIcon from '@material-ui/icons/Mic';

const Intent = ({ intentName, index, url, setCurrentRecording, ...rest }, props) => {
    
    const getNewIntentName = () => {
        return intentName.includes("where") ? 
            intentName.substring(0, intentName.length - 11).replace(/[.]/g, " ") : 
            intentName.substring(0, intentName.indexOf("."))
    };

    return (
        <Box mt={1} alignItems="center" display="flex" flexDirection="column">
            <Typography color="textPrimary" gutterBottom variant="h5">
                script #{index + 1}: {getNewIntentName().toUpperCase()}
            </Typography>
            <Box display="flex" flexDirection="row">
            {
                url ?
                    <audio id="player" src={url} key={index} controls />
                    :
                <Button color="primary" fullWidth variant="contained" disabled>
                    Missing: Record Now 
                </Button> 
            }
                <IconButton color="primary" onClick={async () => setCurrentRecording(intentName)} aria-label="record">
                    <MicIcon />
                </IconButton>
            </Box> 
            
        </Box>
    );
};

Intent.propTypes = {
  className: PropTypes.string
};

export default Intent;
